<div
  class="notification-page-item"
  [class.unread]="!notification.isRead"
  [class.clickable]="isClickable"
  (click)="onClick()"
>
  <!-- Notification content -->
  <div class="notification-content">
    <div class="notification-header">
      <h4 class="notification-title">{{ title }}</h4>
      <span class="notification-time">{{ getTimeAgo() }}</span>
    </div>
    <p class="notification-body">{{ body }}</p>

    <!-- Action indicator for clickable notifications -->
    <div *ngIf="isClickable" class="notification-action">
      <i class="pi pi-arrow-left"></i>
      <span>{{ 'notifications.viewDetails' | translate }}</span>
    </div>
  </div>
</div>
